import { render } from "./AgentNotifications.vue?vue&type=template&id=05092922&scoped=true"
import script from "./AgentNotifications.vue?vue&type=script&lang=js"
export * from "./AgentNotifications.vue?vue&type=script&lang=js"

import "./AgentNotifications.vue?vue&type=style&index=0&id=05092922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05092922"]])

export default __exports__